import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from 'components/header';
import Container from '@mui/material/Container';
import { EtheloWeb3Provider } from 'features/web3/contexts/web3-provider';

const MainLayout = () => {
  return (
    <EtheloWeb3Provider>
      <Header />
      <Container maxWidth="xl">
        <Outlet />
      </Container>
    </EtheloWeb3Provider>
  );
};

export default MainLayout;
